<template>
    <app-content-admin>
        <template slot="header">Reset Password</template>
               
        <v-layout row wrap>

<v-flex xs12 lg6 mx-auto>
    <v-card>
        <v-card-text>           
            <v-container fluid grid-list-xs>
                <v-layout wrap>



                    <v-flex xs12>
                        <v-text-field
                            :label="$t('Password')"
                            v-model="form.password"
                            :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required('Password')]"
                            :type="showpass ? 'text' : 'password'"
                            outlined
                            @click:append="showpass = !showpass"
                        > </v-text-field>
                    </v-flex>

                    

                </v-layout>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="resetPassword"
                class="form-submit"
            >
                Submit
            </v-btn>
        </v-card-actions>
    </v-card>

</v-flex>

</v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from '../../components/status/ActiveLabel.vue';
import store from '@/store'


export default {
    mixins: [vForm],

    data(){
        return {    

            form:{
            password:null,
            id_user:null 
            },        
            showpass: false,           
          }
        },

        components: {ActiveLabel},

        created() {
             this.form.id_user = this.$route.params.id;
             
        },

        methods: {
            async resetPassword(){
                let loader = this.$loading.show();
                try{
                let token = store.getters['auth/token'];
                let res = await axios.post(`/api/auth/reset_password?token=${token}`,this.form)
                     if(res.status == 200){
                        this.$toastr.s('Password reset successfully');  
                    }
                }
                catch(err){
                    this.$toastr.e(err.response.data.message);
                }
                finally{
                    loader.hide();                  
                }
            },
            
        }
}
</script>